export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/kz.7c2ea99d.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};